import React from "react";
import PropTypes from "prop-types";

import globalStyles from "../../../../globalStyles";
import { AngleDown, Button, Section, TypeWriter } from "../../../../components";
import { openUrlInNewTab, scrollToRef } from "../../../../util";
import { personalInfo } from "../../data";
import {
  K_COLORS_DARK_NAVY,
  K_COLORS_LIGHT_BLUE,
  K_MOBILE_SIZE,
} from "../../../../constants";
import { useWindowSize } from "../../../../hooks";

const IntroSection = (props) => {
  const { anchorRef, additionalData } = props;
  const { width } = useWindowSize();

  const styles = {
    ...pcStyles,
    ...(width < K_MOBILE_SIZE ? mobileStyles : {}),
  };

  return (
    <Section style={styles.section} anchorRef={anchorRef}>
      <h1 style={styles.title}>HELLO, I AM</h1>

      <TypeWriter
        text="Jonathan Christopher Jakub"
        style={styles.name}
        speed={75}
        delay={1250}
      />

      <h5 style={styles.content}>
        A Top 1 CS UI Graduate and passionate IT Developer - interested in Software Engineering and Artificial Intelligence.<br/>
        Currently pursuing my passion as a Software Engineer, I have much to take and more to give.<br/>
        I was born for this, and I am ready for it.
      </h5>

      <div style={styles.buttonContainer}>
        <Button
          text="EXPLORE ME"
          fillColor={K_COLORS_DARK_NAVY}
          lineColor={K_COLORS_LIGHT_BLUE}
          style={styles.button}
          onClick={() => scrollToRef(additionalData.nextContentRef)}
        />
        <Button
          text="SEE RESUME"
          fillColor={K_COLORS_LIGHT_BLUE}
          lineColor={K_COLORS_DARK_NAVY}
          style={styles.button}
          onClick={() => openUrlInNewTab(personalInfo.resumeUrl)}
        />
      </div>

      <AngleDown onClick={() => scrollToRef(additionalData.nextContentRef)} />
    </Section>
  );
};

const pcStyles = {
  section: {
    ...globalStyles.fullHeightSection,
    ...globalStyles.darkBackground,
    textAlign: "center",
    paddingTop: "10rem",
    paddingLeft: "6vw",
    paddingRight: "6vw",
  },
  title: {
    ...globalStyles.textTitleSize,
    ...globalStyles.textLightGreyColor,
    ...globalStyles.titleSpacing,
  },
  name: {
    ...globalStyles.textLightBlueColor,
    fontSize: "4rem",
  },
  content: {
    ...globalStyles.textLightGreyColor,
    ...globalStyles.textNormalSize,
  },
  buttonContainer: {
    display: "flex",
    flexDirection: "row",
    flexWrap: "wrap",
    justifyContent: "center",
    paddingTop: "3rem",
    paddingBottom: "1rem",
  },
  button: {
    marginLeft: "1.5rem",
    marginRight: "1.5rem",
    marginTop: "0.5rem",
    marginBottom: "0.5rem",
  },
};

const mobileStyles = {
  section: {
    ...globalStyles.fullHeightSection,
    ...globalStyles.darkBackground,
    textAlign: "center",
    paddingTop: "6rem",
  },
  title: {
    ...globalStyles.textSmallSize,
    ...globalStyles.textLightGreyColor,
    ...globalStyles.titleSpacing,
  },
  name: {
    ...globalStyles.textLightBlueColor,
    fontSize: "2rem",
  },
  content: {
    ...globalStyles.textLightGreyColor,
    ...globalStyles.textSmallerSize,
    marginTop: "0.25rem",
    marginBottom: "0.25rem",
  },
  buttonContainer: {
    display: "flex",
    flexDirection: "column",
    flexWrap: "wrap",
    justifyContent: "center",
    alignItems: "center",
    paddingTop: "1rem",
  },
};

IntroSection.propTypes = {
  anchorRef: PropTypes.shape().isRequired,
  additionalData: PropTypes.shape({
    nextContentRef: PropTypes.shape().isRequired,
  }),
};

export default IntroSection;
